'use client';

import parse from 'html-react-parser';
import {
    checkContentEmpty,
    options,
} from '@app/components/WpPostNavigation/WpPostNavigation.logic';
import ExpandableItem from '@app/components/ExpandableItem/ExpandableItem';
import styles from './WpPostNavigation.module.scss';

export interface IProps {
    /**
     * Состояние поста
     */
    content: string;
}

export default function WpPostNavigationMobile({ content }: IProps) {
    const parsedContent = parse(content, options);
    const isContentEmpty = checkContentEmpty(parsedContent);

    if (isContentEmpty) {
        return null;
    }

    return (
        <ExpandableItem title="Содержание" className={styles['post__navigation_mobile']}>
            {parsedContent}
        </ExpandableItem>
    );
}
